import api from './api';

const auditService = {
  async listEvents(params = {}) {
    const response = await api.get('/audit/kardex/events', { params });
    return response.data;
  },

  async getSummary(params = {}) {
    const response = await api.get('/audit/kardex/summary', { params });
    return response.data;
  },

  async resolveEvent(id, status = 'resolved') {
    const response = await api.post(`/audit/kardex/events/${id}/resolve`, { status });
    return response.data;
  },

  async getNotificationRecipients(warehouseId) {
    const response = await api.get(`/warehouses/${warehouseId}/audit-notification-recipients`);
    return response.data;
  },

  async updateNotificationRecipients(warehouseId, recipients) {
    const response = await api.patch(`/warehouses/${warehouseId}/audit-notification-recipients`, { recipients });
    return response.data;
  },

  async amIRecipient() {
    const response = await api.get('/audit/notification-recipients/me');
    return response.data;
  },

  async getRules() {
    const response = await api.get('/audit/rules');
    return response.data;
  },

  async updateRules(payload) {
    const response = await api.patch('/audit/rules', payload);
    return response.data;
  },
};

export default auditService;
